module.exports = __webpack_public_path__ + "static/img/18.9567759.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/18.jpg
// module id = h0iV
// module chunks = 1